<template>
  <transition name="slide-fade">
  <SidebarMenu v-if="isOpen" :menu="mobileMenu" :disableHover="true" :hideToggle="true" theme="white-theme" v-click-outside="onBlur"></SidebarMenu>
  </transition>
</template>

<script type="text/javascript">
import { SidebarMenu } from 'vue-sidebar-menu'
import ClickOutside from "vue-click-outside";
import Tree from "@/common/utils/tree"
import { curry } from "ramda";


export default {
  name: "EshopSidebarMenu",
  components: {
    SidebarMenu
  },
  directives: { ClickOutside },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    const mobileBtnSidebarMenu = document.getElementsByClassName('mobile-header__menu-button')[0];
    this.popupItem = mobileBtnSidebarMenu;
    this.transformedCatalogTreeMenu = this.transformCatalogTree(this.catalogNav).child;
    this.transformedMainNavTreeMenu = this.transformTree(this.mainMenu).child;
    this.mobileMenu = [{ header: true, title: 'Katalog', hiddenOnCollapse: true }, ...this.transformedCatalogTreeMenu, { header: true, title: 'Hlavní menu',  hiddenOnCollapse: true }, ...this.transformedMainNavTreeMenu];
  },
  methods: {
    transformCatalogTree(tree){
      return Tree.map((node) => { return { href: "/katalog/" + node.slug, title: node.name } }, tree)
    },
    transformTree(tree){
      return Tree.map((node) => { return { href: node.url, title: node.title } }, tree)
    },
    onResize () {
      if (window.innerWidth <= 985) {
        this.isOnMobile = true
        this.collapsed = true
      } else {
        this.isOnMobile = false
        this.collapsed = false
        this.onBlur();
      }
    },
    onBlur() {
      if(this.isOpen === true){
        this.$store.commit("TOGGLE_SIDEBAR_MENU") 
      }
    },
  },
  computed: {
    isOpen() {
      return this.$store.state.isSideBarMenuOpen;
    },
    catalogNav() {
      return { title: "Katalog", children: this.$store.state.pageLayoutModule.pageModel.catalogNav  };
    },
    mainMenu() {
      return this.$store.state.pageLayoutModule.pageModel.mainNav.mainMenu;
    }
  },
  watch: {
    isOpen: (val) => {
      if(val === true){
        window.document.body.classList.add("sidebar-open");
      } else {
        window.document.body.classList.remove("sidebar-open")
      }
    }
  },
  data() {
    return {
      mobileMenu: [],
      menuConfig: [
        {
          header: true,
          title: 'Main Navigation',
          hiddenOnCollapse: true
        },
        {
          href: '/',
          title: 'Dashboard',
          icon: 'fa fa-user'
        },
        {
          title: 'Charts',
          icon: 'fa fa-chart-area',
          child: [
            {
              href: '/charts/sublink',
              title: 'Sub Link'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
/* Enter and leave animations can use different */
///* durations and timing functions.              */
//.slide-fade-enter-active {
//  transition: transform .3s;
//  transition-delay: 0s;
//  
//}
//.slide-fade-leave-active {
//  transition: transform .3s;
//  transition-delay: 0s;
//}
//.slide-fade-enter
//  /* .slide-fade-leave-active below version 2.1.8 */ {
//  transform: translateX(-100%) translateX(-30px);
//}
//
//.slide-fade-leave-to {
//  transform: translateX(0);
//}
#173e8b
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%) translateX(-30px);
  opacity: 0;
}


</style>